import { OysterLogo, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

export const ProvidedByOyster = () => {
  const { t } = useTranslation("global_compensation_calculator/Result")

  return (
    <Text size="small" className="items-center  text-gray-300 md:flex">
      {t("providedByOyster")}&nbsp;
      <OysterLogo size="xs" variant="black" title="Oyster" />
    </Text>
  )
}
